module.exports = __webpack_public_path__ + "static/media/or.5ebf45ec.svg";